import React, { Component } from 'react';
import {connect} from "react-redux";

import moment from 'moment';

import {clearAppointment} from '../../actions/appointments';
import viewHelper from '../../helpers/view';
import CONSTANTS from "../../constants";

class ShowAppointment extends Component {

    bookAnother() {
        let newState = { activity: null, trainer: null, date: null, startTime: null, endTime: null, confirm: false };
        if(this.props.hasOwnProperty('callbackToUpdateComponent')) {
            this.props.callbackToUpdateComponent(newState);
            this.props.clearAppointment();
        }
    }

    render () {
        let appointment = this.props.appointment;
        return (
            <div>
                <div className='col-xs-12 col-md-6 col-lg-6'>
                    <div className='info-box'>
                        <h3>When</h3>
                        <div>{moment(appointment.start_date, CONSTANTS.DATE.FORMAT.DEFAULT).format('dddd, MMMM D, YYYY')} {viewHelper.getFormattedTime(appointment.start_time)} - {viewHelper.getFormattedTime(appointment.end_time)}</div>
                    </div>
                </div>
                <div className='col-xs-6 col-md-6 col-lg-6'>
                    <div className='info-box'>
                        <h3>What</h3>
                        {appointment.activity_name}
                    </div>
                </div>
                <div className='col-xs-6 col-md-12 col-lg-12'>
                    <div className='info-box'>
                        <h3>With</h3>
                        {appointment.trainer_name}
                    </div>
                </div>
                <div className='col-xs-12 col-md-12 col-lg-12'>
                    <button className='btn btn-primary' onClick={this.bookAnother.bind(this)} >Book Another</button>
                </div>
            </div>
        )
    }
}

export default connect(null, { clearAppointment })(ShowAppointment);
